import { types } from '../actions/actionModalActions';

export function actionModals(state = {}, action) {
  switch (action.type) {
    case types.SHOW_MODAL:
      return { ...state, [action.modalName]: true };
    case types.HIDE_MODAL:
      return { ...state, [action.modalName]: false };
    default:
      return state;
  }
}
